import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Badge } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faToggleOff, faToggleOn, faTrash } from '@fortawesome/free-solid-svg-icons'
import { Divider, Empty, message, Popconfirm, Table, Tooltip } from 'antd'

import Pagination from '../../../components/Pagination'
import EditTechnicianModal from './EditTechnicianModal'

import { deleteTechnician, updateTechnician } from '../services'
import { handleError } from '../../../helpers'

export default function TechniciansTable({ technicians, reload, pagination, setPagination }) {
	const currentUser = useSelector(state => state.auth.user)
	const [editModalRecord, setEditModalRecord] = useState(null)
	
	const columns = [
		{
			title: 'Nombre Completo',
			dataIndex: 'name'
		},
		{
			title: 'Documento',
			dataIndex: 'document',
		},
		{
			title: 'Correo Electrónico',
			dataIndex: 'email',
			render: t => t ? t : <em>Sin registro</em>
		},
		{
			title: 'Celular',
			dataIndex: 'mobile',
			render: t => t ? t : <em>Sin registro</em>
		},
		{
			title: 'Estado',
			dataIndex: 'status',
			render: t => <Badge color={t.color}>{t.label}</Badge>
		},
		{
			title: 'Acciones',
			render: (t, r) => (
				<React.Fragment>
					{ (currentUser.role === 'admin' || currentUser.permissions.includes('edit_technicians')) && (
						<React.Fragment>
							<Tooltip title="Editar" onClick={() => setEditModalRecord(r)}>
								<React.Fragment>
									<FontAwesomeIcon icon={faEdit} className="text-link" />
								</React.Fragment>
							</Tooltip>
							<Divider type='vertical' />
							<Tooltip title={r.status.key === 'active' ? 'Inactivar' : 'Activar'}>
								<React.Fragment>
									<FontAwesomeIcon 
										icon={r.status.key === 'active' ? faToggleOff : faToggleOn} 
										className="text-link"
										onClick={() => handleToggle(r.id, r.status.key === 'inactive')}
									/>
								</React.Fragment>
							</Tooltip>
							<Divider type='vertical' />
						</React.Fragment>
					)}
					{ (currentUser.role === 'admin' || currentUser.permissions.includes('delete_technicians')) && (
						<React.Fragment>
							<Tooltip title="Eliminar">
								<React.Fragment>
									<Popconfirm
										title="Esta acción no se puede revertir"
										okText="Eliminar"
										cancelText="Cancelar"
										okButtonProps={{ danger:true }}
										onConfirm={() => handleDelete(r.id)}
									>
										<FontAwesomeIcon icon={faTrash} className="text-link" />
									</Popconfirm>
								</React.Fragment>
							</Tooltip>
						</React.Fragment>
					)}
				</React.Fragment>
			)
		}
	]

	const handleToggle = (id, isActive) => {
		updateTechnician(id, { is_active: isActive ? 1 : 0 })
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(handleError)
	}

	const handleDelete = id => {
		deleteTechnician(id)
			.then(res => {
				message.success(res.data.message)
				reload()
			})
			.catch(handleError)
	}
	
	return (
		<React.Fragment>
			<Table 
				dataSource={technicians}
				rowKey={r => r.id}
				pagination={false}
				columns={columns}
				loading={!technicians}
				size="small"
				locale={{ emptyText: (
					<Empty
						description="No se encontraron registros" 
						styles={{ image: { height: '80px' } }}
					/> 
				)}}
			/>
			<Pagination 
				pagination={pagination}
				setPagination={setPagination}
				reload={reload}
				className="mb-0"
			/>
			{ editModalRecord && (
				<EditTechnicianModal 
					visible
					onClose={() => setEditModalRecord(null)}
					technician={editModalRecord}
					reload={reload}
				/>
			)}
		</React.Fragment>
	)
}